import { Badge, Collapse, Space, Tag, Typography } from 'antd';
import { FC, ReactNode } from 'react';

import { CopyableText, DescriptionBlock, EmptyText } from '../../../../../common/components';
import { getDateFactory } from '../../../../../common/utils';
import { ProxyServerAddressesConfigTag, ProxyServerAddressesHealthTag } from '../../../components';
import { ProxyServerAddress } from '../../../entities';

import { ChevronLeft } from 'react-bootstrap-icons';
import { ProxyServerConfigurationStatuses, ProxyServerHealthStatuses } from '../../../proxyServerAddresses.interfaces';
import './ProxyServerAddressesListView.scss';

interface Props {
  addresses: ProxyServerAddress[];
}

export const ProxyServerAddressesListView: FC<Props> = ({ addresses }) => {
  return (
    <Collapse
      ghost
      expandIconPosition="end"
      className="proxy-server__addresses-list"
      accordion
      expandIcon={(properties): ReactNode => (
        <Badge dot={properties.className?.includes('haveError')}>
          <ChevronLeft size={16} style={{ transition: '300ms', rotate: `${properties.isActive ? -90 : 0}deg` }} />
        </Badge>
      )}
    >
      {addresses.map((address) => (
        <Collapse.Panel
          className={address.configurationStatusError || address.healthStatusError ? 'haveError' : ''}
          key={address.id}
          collapsible="icon"
          header={
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <CopyableText key={address.id} textToCopy={address.ip} style={{ width: '100%' }}>
                {address.ip}
              </CopyableText>
              {address.healthStatus === ProxyServerHealthStatuses.NotWorking &&
              address.configurationStatus === ProxyServerConfigurationStatuses.NotConfigured ? (
                <Tag style={{ minWidth: 220 }} color="gold">
                  в черзі на налаштування
                </Tag>
              ) : (
                <Space size="small">
                  <ProxyServerAddressesHealthTag healthStatus={address.healthStatus} />
                  <ProxyServerAddressesConfigTag configurationStatus={address.configurationStatus} />
                </Space>
              )}
            </div>
          }
        >
          <DescriptionBlock
            colon={false}
            labelStyle={{ marginBottom: -8 }}
            items={[
              [
                'Стан',
                <DescriptionBlock
                  key="healthStatusLastCheckedAt"
                  column={2}
                  items={[
                    [
                      'Востаннє перевірено',
                      <Typography.Text key="healthStatusLastCheckedAt">
                        {address.healthStatusLastCheckedAt ? (
                          getDateFactory(address.healthStatusLastCheckedAt, 'Thursday, August 16, 2018 08:02', true)
                        ) : (
                          <EmptyText />
                        )}
                      </Typography.Text>,
                    ],
                    [
                      'Помилка',
                      <Typography.Text key="healthStatusError" type="danger">
                        {address.healthStatusError || <EmptyText />}
                      </Typography.Text>,
                    ],
                  ]}
                />,
              ],
            ]}
          />
          <DescriptionBlock
            colon={false}
            labelStyle={{ marginBottom: -8 }}
            items={[
              [
                'Проксі для запитів',
                <DescriptionBlock
                  key="configurationStatusLastCheckedAt"
                  column={2}
                  items={[
                    [
                      'Востаннє перевірено',
                      <Typography.Text key="configurationStatusLastCheckedAt">
                        {address.configurationStatusLastCheckedAt ? (
                          getDateFactory(address.configurationStatusLastCheckedAt, 'Thursday, August 16, 2018 08:02', true)
                        ) : (
                          <EmptyText />
                        )}
                      </Typography.Text>,
                    ],
                    [
                      'Помилка',
                      <Typography.Text key="configurationStatusError" type="danger">
                        {address.configurationStatusError ?? <EmptyText />}
                      </Typography.Text>,
                    ],
                  ]}
                />,
              ],
            ]}
          />
        </Collapse.Panel>
      ))}
    </Collapse>
  );
};
